import { useNavigate } from "react-router-dom";
import CustomButton from "../components/customButton";
import CustomInputIcon from "../components/customInputIcon";
import { useMutation } from "react-query";
import { userLogin } from "../api/auth";
import { useState } from "react";
import toast from "react-hot-toast";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const login = useMutation(userLogin, {
        onSuccess: async (res) => {
            console.log(res);

            if (res.message.success_key === 1){
                const { api_key, api_secret, email, username, full_name, sid } = res.message;
                localStorage.setItem('token', `${api_key}:${api_secret}`);
                localStorage.setItem('email', email);

                toast.success("Login berhasil!");
                navigate('/sales-orders');
            } else {
                toast.error(res.message?.error_message || "Email atau password salah");
            }   
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || "Terjadi kesalahan, coba lagi");
        }

    })

    const handleLogin = () => {
        login.mutate({
            usr: email,
            pwd: password
        })
    }
    return (
        <div className="w-full h-screen flex flex-col items-center justify-center bg-gradient-to-b from-[#203E6F] to-[#4169E1]">
            <div className="flex flex-col w-full max-w-md sm:max-w-lg lg:max-w-xl px-6 py-10 rounded-xl justify-center bg-white shadow-md mt-8 items-center">
                <img src="/logo.png" className="w-40"></img>
                <h1 className="font-bold text-xl text-center text-[#203E6F] mt-6">Selamat Datang di</h1>
                <h1 className="font-bold text-2xl text-center text-[#203E6F]">Portal Customer Arkha</h1>
                <p className="text-center text-gray-500">Silahkan Masukkan Email dan Password Anda</p>
                <div className="w-full mt-4 gap-4 flex flex-col">
                    <div>
                        <span>Email</span>
                        <CustomInputIcon 
                            value={email} 
                            name="email" 
                            placeholder={"Email"}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full p-3 rounded-md text-black placeholder-gray-400"
                        />           
                    </div>

                    <div>
                        <span>Password</span>
                        <CustomInputIcon 
                            value={password} 
                            name="password" 
                            placeholder={"Password"}  
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-3 rounded-md text-black placeholder-gray-400"

                        />           
                    </div>

                    <CustomButton
                        text="Login"
                        onClick={() => handleLogin()}
                        isLoading={login.isLoading}
                    />

                </div>   
            </div>

        </div>
    )
};

export default Login